import { type FC, lazy, Suspense, type ReactNode, type JSX } from 'react';
import { useFragment, graphql } from 'react-relay';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

import styles from './LazyThumbVideo.module.css';

import { type LazyThumbVideo_viewer$key } from './__generated__/LazyThumbVideo_viewer.graphql.ts';

type ThumbVideoProps = {
    viewer: LazyThumbVideo_viewer$key;
    itemId: string;
    poster?: string;
    children: ReactNode;
};

const viewerFragment = graphql`
    fragment LazyThumbVideo_viewer on Viewer {
        ...ThumbVideo_viewer
    }
`;

const ThumbVideo = lazy(() =>
    import('./ThumbVideo.tsx').then(module => ({ default: module.ThumbVideo }))
);

const TileSpinner = (): JSX.Element => (
    <div className={styles.lazyVideoSpinner}>
        <Spinner black />
    </div>
);

export const LazyThumbVideo: FC<ThumbVideoProps> = ({ viewer: viewerRef, ...props }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const isClient = useClientState();

    return isClient ? (
        <Suspense fallback={<TileSpinner />}>
            <ThumbVideo {...props} viewer={viewer} />
        </Suspense>
    ) : null;
};
